module.exports = __webpack_public_path__ + "img/20210119.f9b6dbb5.png";